class CareServicesDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", evt => evt.code === "Escape" && this.close());
    this.querySelector("#CareServicesDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setTriggerAccessibility();

    // Close care services drawer when cart is opened
    window.addEventListener('cart-opened', this.close.bind(this));
  }

  setTriggerAccessibility() {
    const triggers = document.querySelectorAll(".care-services-trigger");
    triggers.forEach(trigger => {
      trigger.setAttribute("role", "button");
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.addEventListener("click", event => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener("keydown", event => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Timeout helps with animation trigger
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("CareServicesDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    setTimeout(() => {
      document.body.classList.add("overflow-hidden");
    }, 10);

    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || document.querySelector(".header-wrapper")?.classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().top)}px`);

    // Dispatch custom event
    const drawerOpened = new Event('care-services-drawer-opened');
    window.dispatchEvent(drawerOpened);
  }

  close() {
    // Only animate if drawer is actually open
    if (!this.classList.contains("active")) return;
    
    // Add closing class for animation - matching global drawer pattern
    this.classList.add("closing");
    this.classList.remove("active");

    // Wait for animation to complete before cleanup (matches --animation-duration-4: 0.4s = 400ms)
    setTimeout(() => {
      this.classList.remove("closing", "animate");
    }, 400);

    // Remove focus trap and re-enable body scroll
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("care-services-drawer", CareServicesDrawer);
